import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-late-charges',
  templateUrl: './modal-late-charges.component.html',
  styleUrls: ['./modal-late-charges.component.scss'],
})
export class ModalLateChargesComponent implements OnInit {

  @Input() title: any;
  @Input() image: any;
  @Input() text: any;
  @Input() reservation: any;
  @Input() buttons: any;
  @Input() small: any;
  public environment = environment;
  constructor(
    public router: Router,
    private modalCtrlr: ModalController,) { }

  ngOnInit() {}

  close(close: boolean){
    this.modalCtrlr.dismiss({data: close});
  }
}
